import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import { useLanguageContext } from "../../Context/LanguageContext";
const EnhancedTableHead = (props) => {
  const { localization } = useLanguageContext();
  const {
    classes,
    onSelectAllClick,
    numSelected,
    ItemList,
    isRowClickble,
    columnName,
  } = props;
  const [headCell, setHeadCell] = useState([]);

  useEffect(() => {
    if (ItemList.length > 0) {
      const _tempItem = ItemList.map((item) => ({
        id: item.id,
        numeric: true,
        disablePadding: false,
        label: item.label,
      }));
      setHeadCell(_tempItem);
    }
  }, [ItemList]);

  return (
    <TableHead className={classes.stickyHeader}>
      <TableRow>
        {isRowClickble && (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0}
              checked={numSelected === ItemList.length}
              onChange={onSelectAllClick}
              inputProps={{ "aria-label": "select all desserts" }}
            />
          </TableCell>
        )}
        <TableCell className={classes.labelStyle} key={1}>
          {columnName}
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

EnhancedTableHead.propTypes = {
  onSelectAllClick: PropTypes.func.isRequired,
  numSelected: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    display: "flex",
    justifyContent: "space-between",
  },
  title: {
    flex: "1 1 100%",
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#e0e0e0",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
    marginLeft: 0,
    width: "100%",
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + 32px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    fontSize: "14px",
  },
  toolTip: {
    fontSize: "14px",
  },
  deleteIcon: {
    width: "1.5em",
    height: "1.5em",
  },
}));

const EnhancedTableToolbar = (props) => {
  const { localization } = useLanguageContext();
  const classes = useToolbarStyles();
  const { numSelected, onSearchChange, title, deletdHandle } = props;

  return (
    <Toolbar className={classes.root}>
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography
            className={classes.toolTip}
            variant="subtitle1"
            component="div"
          >
            {numSelected} {localization.selected}
          </Typography>
        ) : (
          <Typography variant="h6" id="tableTitle" component="div">
            {title}
          </Typography>
        )}
      </div>
      {numSelected > 0 ? (
        <Tooltip className={classes.toolTip} title="Delete">
          <IconButton
            aria-label="delete"
            classes={{ root: classes.selectedIconRoot }}
            onClick={deletdHandle}
          >
            <DeleteIcon className={classes.deleteIcon} />
          </IconButton>
        </Tooltip>
      ) : (
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            placeholder={localization.search}
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            inputProps={{ "aria-label": "search" }}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
      )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onSearchChange: PropTypes.func.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: "5px",
    fontSize: 14,
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  tableContainer: {
    maxHeight: 400,
    overflowY: "auto",
  },
  table: {
    minWidth: 750,
  },
  stickyHeader: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: theme.palette.background.paper,
  },
  labelStyle: {
    fontSize: "14px",
    color: "white",
  },
  tableContant: {
    fontSize: "14px",
  },
  selectedIconRoot: {
    color: theme.palette.error.main,
    width: "1.5rem",
    height: "1.5rem",
  },
  title: {
    fontSize: "1.5rem",
  },
}));

export default function EnhancedTable({
  ItemList,
  title,
  columnName,
  setItemSelected,
  deletdHandle,
  isRowClickble = true,
}) {
  const { localization } = useLanguageContext();
  const classes = useStyles();
  const [selected, setSelected] = React.useState([]);
  const [searchValue, setSearchValue] = React.useState("");
  const [filteredRows, setFilteredRows] = React.useState(ItemList);

  useEffect(() => {
    setItemSelected(selected);
  }, [selected]);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = ItemList.map((n) => n.id);
      setSelected(newSelecteds);
    } else {
      setSelected([]);
    }
  };

  const handleClick = (event, _id) => {
    const selectedIndex = selected.indexOf(_id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, _id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleSearchChange = (value) => {
    setSearchValue(value);
    const filtered = ItemList.filter((row) =>
      Object.values(row).some((val) =>
        String(val).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredRows(filtered);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  useEffect(() => {
    if (ItemList.length > 0) {
      setFilteredRows(ItemList);
    } else {
      setFilteredRows([]);
    }
    setSelected([]);
  }, [ItemList]);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar
          numSelected={selected.length}
          onSearchChange={handleSearchChange}
          className={classes.title}
          title={title}
          deletdHandle={deletdHandle}
        />
        <div className={classes.tableContainer}>
          <TableContainer style={{ maxHeight: "40vh" }}>
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead
                onSelectAllClick={handleSelectAllClick}
                numSelected={selected.length}
                classes={classes}
                ItemList={ItemList}
                isRowClickble={isRowClickble}
                columnName={columnName}
              />

              <TableBody>
                {filteredRows.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      {localization.noRecordFound}
                    </TableCell>
                  </TableRow>
                ) : (
                  <>
                    {" "}
                    {filteredRows.map((row, index) => {
                      const isItemSelected = isSelected(row.id);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow
                          hover
                          onClick={(event) => {
                            if (isRowClickble) {
                              handleClick(event, row.id);
                            }
                          }}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.label}
                          selected={isItemSelected}
                          className={classes.tableContant}
                        >
                          {isRowClickble && (
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                inputProps={{ "aria-labelledby": labelId }}
                              />
                            </TableCell>
                          )}
                          <TableCell
                            component="th"
                            id={labelId}
                            scope="row"
                            padding={isRowClickble ? "none" : "1rem"}
                          >
                            {row.label}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Paper>
    </div>
  );
}
